import { useSessionStorage } from '@vueuse/core';

const LOCAL_KEY = 'is-sidebar-collapsed';
const DEFAULT_VALUE = false;

export const isCollapsed = useSessionStorage(LOCAL_KEY, DEFAULT_VALUE);

export const handleToggle = () => {
  isCollapsed.value = !isCollapsed.value;
};
